import { ReactNode } from 'react'
import styles from './styles/PageHeading.module.css'

type PageHeadingProps = {
  title: string
  description?: ReactNode
  /** Ações à direita do título (ex.: botão "Adicionar"). */
  actions?: ReactNode
  /**
   * Imagem à esquerda do título (ex.: avatar do paciente). Decorativa: o nome já está no título,
   * então passe a imagem com `alt=''`.
   */
  avatar?: ReactNode
}

/**
 * Título + descrição da tela, fora do card da listagem (ex.: acima do <TableCard>).
 * Usa <h2> porque o <h1> da página já é renderizado no header do layout (DefaultTitle).
 */
export const PageHeading = ({ title, description, actions, avatar }: PageHeadingProps) => (
  <div className={styles.heading}>
    <div className={styles.identity}>
      {avatar && <div className={styles.avatar}>{avatar}</div>}
      <div className={styles.text}>
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
    {actions}
  </div>
)
